import { useState, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const useDiscountAnalysis = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });


  const fetchDiscountAnalysis = useCallback(async (overrideFilters) => {
    try {
      setLoading(true);
      setError(null);

      const finalFilters = overrideFilters ?? filters;

      const response =
        await ReportsService.getDiscountAnalysis(finalFilters);


      setData(response?.data ?? []);
      setSummary(response?.summary ?? response?.data?.summary ?? null);
      setBranchSummary(response?.branchSummary ?? []);
      setTotal(response?.total ?? response?.data?.total ?? 0);

    } catch (err) {
      console.error(err);
      setError('Failed to load discount analysis');
      toast.error('Failed to load discount analysis');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  return {
    data,
    summary,
    branchSummary,
    total,
    loading,
    error,
    filters,
    setFilters,
    fetchDiscountAnalysis,
  };
};

export default useDiscountAnalysis;
